import { useEffect, useState } from 'react'
import { loadMyWorkCount, onMyWorkChanged } from '../lib/myWork'

// The number beside My work in the sidebar, and on the bell: how many tasks
// are waiting for the reader, which is the number of rows My work shows on its
// whole list (the link both open). Both read lib/myWork.ts, so they agree with
// each other, with Home and with the list. Notices are news, not tasks, and
// are not in it.
//
// It shows nothing rather than a zero or an error: a badge is a prompt to act,
// not a status report.

export function useMyWorkTotal(): number {
  const [n, setN] = useState(0)
  useEffect(() => {
    let live = true
    const read = () => {
      loadMyWorkCount()
        .then((w) => {
          if (live) setN(w.total)
        })
        .catch(() => undefined)
    }
    // One turn late, so a Home mounting in the same commit hands over the
    // count its panel carries before this asks for it (lib/myWork.ts).
    const first = setTimeout(read, 0)
    window.addEventListener('hashchange', read)
    const off = onMyWorkChanged(read)
    return () => {
      live = false
      clearTimeout(first)
      window.removeEventListener('hashchange', read)
      off()
    }
  }, [])
  return n
}

export function MyWorkCount() {
  const n = useMyWorkTotal()
  if (n === 0) return null
  return (
    <span className="badge" aria-label={n + ' waiting for you'}>
      {n}
    </span>
  )
}
